import * as React from 'react';
import { SVGProps } from 'react';

const SvgMedicationsOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <g clipPath="url(#a)">
      <path
        d="m14.442 9.075 4 2.572c1.533.987 2.018 3.101 1.08 4.713-.598 1.027-1.639 1.64-2.785 1.64a3.134 3.134 0 0 1-1.699-.504l-4.265-2.741.012-.105c.108-.946.503-2.922 1.915-4.372.025.056 3.976 2.62 3.976 2.62.051.033.107.047.162.047a.305.305 0 0 0 .263-.155.335.335 0 0 0-.102-.448L13.147 9.87a5.396 5.396 0 0 1 1.221-.762l.074-.033ZM7.412 5c.627 0 1.242.182 1.777.527l4.474 2.877-.728.466c-1.89 1.21-2.619 3.247-2.897 4.744l-.144.772-4.264-2.742C4.026 10.612 3.52 8.4 4.5 6.714 5.125 5.641 6.214 5 7.412 5Zm0 1.093c-.833 0-1.59.446-2.024 1.192-.683 1.172-.33 2.709.784 3.426l3.015 1.938c.341-1.289 1.052-2.977 2.53-4.215l-3.07-1.975c-.373-.239-.8-.366-1.235-.366Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgMedicationsOutlined;
